import { sendGAEvent } from '../utils';

export enum AdditionalDataEventEnum {
  additional_user_data_form_appearance = 'additional_user_data_form_appearance',
  additional_user_data_form_result = 'additional_user_data_form_result',
  additional_user_data_form_close = 'additional_user_data_form_close',
}

export interface IAdditionalDataResult {
  status: 'success' | 'failed';
  error_data?: any;
  request_data?: Record<string, any>;
}

/**
 * @description This function uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `additional_user_data_form_appearance` and the category is `additional_user_data`.
 */
export const sendAdditionalUserDataAppearanceEvent = () => {
  sendGAEvent(AdditionalDataEventEnum.additional_user_data_form_appearance, {
    event_category: 'additional_user_data',
  });
};

/**
 *
 * @param {IAdditionalDataResult} data - The data object containing registration event details.
 * @description This function sends a Google Analytics event when the registration form is submitted.
 * It uses the `gtag` function to send the event with the specified data.
 * The data object should contain the following properties:
 */
export const sendAdditionalUserDataResultEvent = (
  data: IAdditionalDataResult
) => {
  try {
    sendGAEvent(AdditionalDataEventEnum.additional_user_data_form_result, {
      event_category: 'additional_user_data',
      ...data,
      error_data: data.error_data && JSON.stringify(data.error_data),
    });
    return;
  } catch (e) {
    console.error('Error sending additional user data result event:', e);
    return;
  }
};

/**
 * @description This function uses the `sendGAEvent` utility to send the event with the specified event name and category.
 * The event name is `additional_user_data_form_close` and the category is `additional_user_data`.
 * The event is triggered when the user closes the additional user data form.
 */
export const sendAdditionalUserDataFormCloseEvent = () => {
  sendGAEvent(AdditionalDataEventEnum.additional_user_data_form_close, {
    event_category: 'additional_user_data',
  });
};
